// The background location task must be defined before the app starts (it also runs when
// Android wakes the app in the background), so it is imported first.
import './src/tracking/task';
import 'expo-router/entry';
